import { ReactElement } from 'react';
import { ReactComponent as StateHintImage } from '../../../../../assets/img/overview/stateHint.svg';
import { StateHintContainer } from './styles';
import { useTranslation } from 'react-i18next';

export function StateHint(): ReactElement {
  const { t } = useTranslation();

  return (
    <StateHintContainer>
      <div>
        <StateHintImage />
      </div>
      <span>
        {t('passeMouseEstadoVisualizarInformacoes')}
      </span>
    </StateHintContainer>
  );
}
